import axios from "axios";

import { ApiService } from "../../../servicios/api.service";
import LocalStorageKeys from "../../../data/localStorageKeys";

export class SolicitudComercioApi {
  static endPoint = "solicitud/";
  static endointRechazarBeneficio = "admin/beneficio/";
  
  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get BasePathRechazarBeneficio() {
    return ApiService.api + this.endointRechazarBeneficio;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static acceptById(id) {
    return axios.put(
      this.BasePath + id + "/accept",
      // Es necesario un body para que funcione el put
      {},
      this.Config
    );
  }

  static async count() {
    const response = await axios.get(this.BasePath + "count", this.Config);

    return response.data;
  }

  static async getList(filter) {
    const response = await axios.post(
      this.BasePath + "filter",
      filter,
      this.Config
    );

    return response.data;
  }

  static rejectById(id, motivoRechazo) {
    return axios.put(
      this.BasePathRechazarBeneficio + id + "/rechazar",
      { motivo: motivoRechazo },
      this.Config
    );
  }

  static async update(dto) {
    const response = await axios.patch(this.BasePath, dto, this.Config);

    return response.data;
  }
}
